module.exports = __webpack_public_path__ + "static/media/DigestiveSystem_LowNormalsMap.79fc1152.jpg";